/*
Don't change this file manually.
It is autogenerated by @plone/registry.
Instead, change the "addons" registration in the app.
*/

const projectConfigLoader = require('@root/config');
import plonevoltoSlate from '@plone/volto-slate';
import ploneCollectivevoltoAuthomatic from '@plone-collective/volto-authomatic';
import nsdiVoltoFrontend from 'nsdi-volto-frontend';

const addonsInfo = [{"name":"@plone/volto-slate","version":"18.8.1","isPublishedPackage":true,"isRegisteredAddon":false,"modulePath":"/app/core/packages/volto-slate/src","packageJson":"/app/core/packages/volto-slate/package.json","basePath":"/app/core/packages/volto-slate","tsConfigPaths":null,"addons":[]},{"name":"@plone-collective/volto-authomatic","version":"2.0.4","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/app/node_modules/.pnpm/@plone-collective+volto-authomatic@2.0.4_@plone+volto@core+packages+volto/node_modules/@plone-collective/volto-authomatic/src","packageJson":"/app/node_modules/.pnpm/@plone-collective+volto-authomatic@2.0.4_@plone+volto@core+packages+volto/node_modules/@plone-collective/volto-authomatic/package.json","basePath":"/app/node_modules/.pnpm/@plone-collective+volto-authomatic@2.0.4_@plone+volto@core+packages+volto/node_modules/@plone-collective/volto-authomatic","tsConfigPaths":["src",{}],"addons":[]},{"name":"nsdi-volto-frontend","version":"1.0.0-alpha.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/app/packages/nsdi-volto-frontend/src","packageJson":"/app/packages/nsdi-volto-frontend/package.json","basePath":"/app/packages/nsdi-volto-frontend","tsConfigPaths":[null,{"@plone/volto/*":["../../core/packages/volto/src/*"],"nsdi-volto-frontend/*":["./src/*"]}],"addons":[]}];
export { addonsInfo };

const safeWrapper = (func) => (config) => {
  const res = func(config);
  if (typeof res === 'undefined') {
    throw new Error("Configuration function doesn't return config");
  }
  return res;
}


const projectConfig = (config) => {
  return projectConfigLoader && typeof projectConfigLoader.default === "function" ? projectConfigLoader.default(config) : config;
}

const load = (config) => {
  const addonLoaders = [plonevoltoSlate, ploneCollectivevoltoAuthomatic, nsdiVoltoFrontend];
  if(!addonLoaders.every((el) => typeof el === "function")) {
    throw new TypeError(
      'Each addon has to provide a function applying its configuration to the projects configuration.',
    );
  }
  return projectConfig(addonLoaders.reduce((acc, apply) => safeWrapper(apply)(acc), config));
};
export default load;
